import React, { useEffect, useState } from "react";
import {
    Box,
    IconButton,
    Tooltip,
    Popover,
    TextField,
    Autocomplete,
    Checkbox,
    Typography,
    Paper,
    Grid,
} from "@mui/material";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { filterTypeOptions } from "../../utils/constant";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useDispatch } from "react-redux";
import { setFilterField } from "../../containers/filter-container/reducer/filterSlice";
import { useSelector } from "react-redux";
import { formatMultiQueryParams } from "../../utils/helperFunction";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

// Different filter options for different columns
// const filterOptions = {
//     status: [
//         { title: "All Status" },
//         { title: "Live" },
//         { title: "DeaActivated" },
//         { title: "Approved" },
//     ],
//     name: [
//         { title: 'Amity University Online' },
//         { title: 'Manipal Academy of Higher Education' },
//         { title: 'Dr. D.Y. Patil Pune' },
//         { title: 'Shoolini University' },
//         { title: 'Galgotias University Online', }
//     ],
//     tag: [
//         { title: 'Trending' },
//         { title: 'Top Rated' },
//         { title: 'High Demand' },
//         { title: 'UnCategorizes' },
//     ],
//     universityId: [
//         { title: 'UNI-000038' },
//         { title: 'UNI-000039' },
//         { title: 'UNI-000040' },
//         { title: 'UNI-000041' },
//     ],
//     course: [
//         { title: 'Master of Business Administration' },
//         { title: 'Bachelor of Business Administration'},
//     ]
// };

const dateFieldStyle = {
    '& .MuiInputBase-root': {
        height: '35px',
        fontSize: { xl: '13px', lg: '13px', md: '13px', md: '13px', xs: '12px' }, width: '100%',
    },
    '& input': {
        padding: '6px 8px',
        width: '100%',
    },

}

const getDefaultValue=(type)=>{
    switch (type) {
        case filterTypeOptions.string:
            return ""
        case filterTypeOptions.selection:
            return []
        case filterTypeOptions.numberRange:
            return {}
        case filterTypeOptions.dateRange:
            return {}
        default:
            return null
    }
}
const FilterDataTable = ({ filterAnchorEl, filterColumn, handleFilterClose, handleFilterApply=()=>{},handleFliterSliceChange,pageFilters }) => {
    const [filters, setFilters] = useState({});
    const filterType = filterColumn?.filterType
    const currentColumn = filterColumn?.filterColumnName;
    const currentOptions = filterColumn?.selection || [];
    const defaultValue = getDefaultValue(filterType)

    const selectedValues = filters[currentColumn] || defaultValue;

    const handleSelectAll = () => {
        setFilters((prev) => ({
            ...prev,
            [currentColumn]: currentOptions,
        }));
    };

    const handleClearAll = () => {
        const storeValues = {...filters}
        delete storeValues[currentColumn]
        setFilters(storeValues)
        handleFliterSliceChange(storeValues,true)
        // dispatch(setFilterField({pathname:locationFilterType,filters:JSON.stringify(storeValues)}))
        handleFilterApply(storeValues);
        handleFilterClose();
    };

    const handleSelectionChange = (event, newValue) => {
        setFilters((prev) => ({
            ...prev,
            [currentColumn]: newValue,
        }));
    };

    const handleApply = () => {
        handleFliterSliceChange(filters)
        // dispatch(setFilterField({pathname:locationFilterType,filters:JSON.stringify(filters)}))
        handleFilterApply(filters);
        handleFilterClose();
    };

    useEffect(()=>{
        if(pageFilters){
            setFilters(pageFilters)
        }
    },[pageFilters])
    


    return (
        <Popover
            open={Boolean(filterAnchorEl)}
            anchorEl={filterAnchorEl}
            onClose={handleFilterClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            transformOrigin={{ vertical: "top", horizontal: "center" }}
            PaperProps={{
                elevation: 4,
                component: Paper,
                sx: {
                    overflow: "visible",
                    minWidth: 360,
                    maxWidth: 400,
                    maxHeight: 480,
                    p: 2,
                    borderRadius: "14px",
                    background: "linear-gradient(135deg, #ffffff, #f9fafc)",
                    boxShadow:
                        "0 8px 24px rgba(0,0,0,0.12), inset 0 1px 1px rgba(255,255,255,0.15)",
                    position: "relative",
                    "&::before": {
                        content: '""',
                        position: "absolute",
                        top: -8,
                        left: "50%",
                        transform: "translateX(-50%) rotate(45deg)",
                        width: 16,
                        height: 16,
                        background: "#fff",
                        boxShadow: "-1px -1px 2px rgba(0,0,0,0.1)",
                        zIndex: 0,
                    },
                },
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 0.5,
                    px: 0.5,
                }}
            >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    {/* <FilterAltOutlinedIcon sx={{ color: "#1976D2" }} /> */}
                    <Typography
                        sx={{ fontWeight: 600, color: "#000", fontSize: 20 }}
                    >
                        {filterColumn?.headerName || "Filter"}
                    </Typography>
                </Box>
                <Box sx={{ display: "flex", gap: 0.5, alignItems: "center" }}>
                    {filterType && filterType === filterTypeOptions.selection && <Tooltip title="Select All">
                        <IconButton
                            size="small"
                            onClick={handleSelectAll}
                            sx={{
                                color: "#0288D1",
                                "&:hover": { backgroundColor: "rgba(2,136,209,0.1)" },
                            }}
                        >
                            <DoneAllIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>}
                    <Tooltip title="Clear All">
                        <IconButton
                            size="small"
                            onClick={handleClearAll}
                            sx={{
                                color: "#E64A19",
                                "&:hover": { backgroundColor: "rgba(230,74,25,0.1)" },
                            }}
                        >
                            <RestartAltIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Apply Filter">
                        <IconButton
                            size="small"
                            onClick={handleApply}
                            sx={{
                                color: "#2E7D32",
                                "&:hover": { backgroundColor: "rgba(46,125,50,0.1)" },
                            }}
                        >
                            <TaskAltIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                </Box>
            </Box>

            {/* for selection */}
            {filterType && filterType === filterTypeOptions.selection &&
                <Autocomplete
                    multiple
                    disablePortal
                    disableCloseOnSelect
                    options={currentOptions}
                    value={selectedValues}
                    onChange={handleSelectionChange}
                    getOptionLabel={(option) => option?.label}
                    // ✅ Fix: Compare options properly
                    isOptionEqualToValue={(option, value) => option?.value === value.value}
                    ListboxProps={{
                        sx: {
                            maxHeight: 300,
                            overflowY: "auto",
                            "& li.Mui-focused": {
                                backgroundColor: "rgba(25,118,210,0.08)",
                            },
                        },
                    }}
                    renderOption={(props, option, { selected }) => (
                        <li {...props} style={{ padding: '0', height: '34px' }}>
                            <Checkbox
                                icon={icon}
                                checkedIcon={checkedIcon}
                                style={{ marginRight: 8 }}
                                checked={selected}
                            />
                            {option?.label}
                        </li>
                    )}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            placeholder="Search options..."
                            size="small"
                            sx={{
                                "& .MuiOutlinedInput-root": {
                                    borderRadius: "8px",
                                    backgroundColor: "#fff",
                                    "&:hover": { backgroundColor: "#f5f5f5" },
                                    "& fieldset": { borderColor: "#d0d0d0" },
                                    "&:hover fieldset": { borderColor: "#1976D2" },
                                },
                            }}
                        />
                    )}
                />}

            {/* for search  */}
            {filterType && filterType === filterTypeOptions.string &&
                <TextField
                    value={selectedValues}
                    onChange={(e) => handleSelectionChange(e, e?.target?.value)}
                    placeholder={`Enter ${filterColumn?.headerName}`}
                    size="small"
                    sx={{
                        width: "100%",
                        "& .MuiOutlinedInput-root": {
                            borderRadius: "8px",
                            backgroundColor: "#fff",
                            "&:hover": { backgroundColor: "#f5f5f5" },
                            "& fieldset": { borderColor: "#d0d0d0" },
                            "&:hover fieldset": { borderColor: "#1976D2" },
                        },
                        maxHeight: 300,
                        overflowY: "auto",
                        "& li.Mui-focused": {
                            backgroundColor: "rgba(25,118,210,0.08)",
                        },
                    }}
                />
            }

             {/* for number  */}
            {filterType && filterType === filterTypeOptions.number &&
                <TextField
                    value={selectedValues}
                    onChange={(e) =>  !isNaN(e?.target?.value) &&  handleSelectionChange(e, e?.target?.value)}
                    placeholder={`Enter Number`}
                    size="small"
                    sx={{
                        width: "100%",
                        "& .MuiOutlinedInput-root": {
                            borderRadius: "8px",
                            backgroundColor: "#fff",
                            "&:hover": { backgroundColor: "#f5f5f5" },
                            "& fieldset": { borderColor: "#d0d0d0" },
                            "&:hover fieldset": { borderColor: "#1976D2" },
                        },
                        maxHeight: 300,
                        overflowY: "auto",
                        "& li.Mui-focused": {
                            backgroundColor: "rgba(25,118,210,0.08)",
                        },
                    }}
                />
            }

            {/* for number  */}
            {filterType && filterType === filterTypeOptions.numberRange &&
                <Grid container spacing={3}>
                    <Grid size={6}>
                        <TextField
                             value={selectedValues?.gte || ""}
                            onChange={(e) => !isNaN(e?.target?.value) && handleSelectionChange(e, {...(selectedValues || {}),gte:e?.target?.value})}
                            placeholder={`Enter Number >=`}
                            size="small"
                            sx={{
                                width: "100%",
                                "& .MuiOutlinedInput-root": {
                                    borderRadius: "8px",
                                    backgroundColor: "#fff",
                                    "&:hover": { backgroundColor: "#f5f5f5" },
                                    "& fieldset": { borderColor: "#d0d0d0" },
                                    "&:hover fieldset": { borderColor: "#1976D2" },
                                },
                                maxHeight: 300,
                                overflowY: "auto",
                                "& li.Mui-focused": {
                                    backgroundColor: "rgba(25,118,210,0.08)",
                                },
                            }}
                        />
                    </Grid>
                    <Grid size={6}>
                        <TextField
                            value={selectedValues?.lte || ""}
                             onChange={(e) => !isNaN(e?.target?.value) && handleSelectionChange(e, {...(selectedValues || {}),lte:e?.target?.value,})}
                           placeholder={`Enter Number <`}
                            size="small"
                            sx={{
                                width: "100%",
                                "& .MuiOutlinedInput-root": {
                                    borderRadius: "8px",
                                    backgroundColor: "#fff",
                                    "&:hover": { backgroundColor: "#f5f5f5" },
                                    "& fieldset": { borderColor: "#d0d0d0" },
                                    "&:hover fieldset": { borderColor: "#1976D2" },
                                },
                                maxHeight: 300,
                                overflowY: "auto",
                                "& li.Mui-focused": {
                                    backgroundColor: "rgba(25,118,210,0.08)",
                                },
                            }}
                        />
                    </Grid>
                </Grid>
            }

             {/* for date range  */}
            {filterType && filterType === filterTypeOptions.dateRange &&
                <Box>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Box sx={{ display: "flex", gap: 2, justifyContent: 'space-between', }}>
                            <DatePicker
                                sx={{
                                    '& .MuiSvgIcon-root': {
                                        fontSize: '21px'
                                    },
                                    '& .MuiPickersInputBase-root': {
                                        height: '30px',
                                        borderRadius: '40px',
                                        fontSize: '14px',
                                        width: '170px'
                                    },
                                    '& .MuiInputLabel-formControl': {
                                        top: '-11px',
                                        fontSize: '14px',
                                    }
                                    ,
                                    ' & .MuiFormLabel-filled': {
                                        top: '0'
                                    }
                                    , '& .MuiInputLabel-shrink': {
                                        top: '0px',
                                    },

                                }}
                                label={"Start date"}
                                value={selectedValues?.gte ? dayjs(selectedValues?.gte) : null}
                                onChange={(newValue) => handleSelectionChange({}, { ...(selectedValues || {}), gte: newValue })}
                                // maxDate={filterColumn?.maxDate || null}
                                renderInput={(params) => <TextField
                                    {...params}
                                    sx={dateFieldStyle}
                                />}
                            />
                            <DatePicker
                                sx={{
                                    '& .MuiSvgIcon-root': {
                                        fontSize: '21px'
                                    },
                                    '& .MuiPickersInputBase-root': {
                                        height: '30px',
                                        borderRadius: '40px',
                                        fontSize: '14px',
                                        width: '170px'
                                    }, '& .MuiInputLabel-formControl': {
                                        top: '-11px',
                                        fontSize: '14px',

                                    }
                                    , ' & .MuiFormLabel-filled': {
                                        top: '0'
                                    }
                                    , '& .MuiInputLabel-shrink': {
                                        top: '0px',
                                    },
                                }}
                                label="End date"
                                value={selectedValues?.lte ? dayjs(selectedValues?.lte) : null}
                                onChange={(newValue) => handleSelectionChange({}, { ...(selectedValues || {}), lte: newValue})}
                                renderInput={(params) => <TextField {...params} sx={dateFieldStyle} />}
                            // maxDate={filterColumn?.maxDate || null} // ✅ ensures endDate is after startDate
                            />
                        </Box>
                    </LocalizationProvider>
                </Box>
            }
            
        </Popover>
    );
};
export default FilterDataTable;
